import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { completeVideoPreroll } from '../actions/MediaPlayerActions';
import VideoPrerollModal from '../components/VideoPrerollModal';

const VideoPrerollContainer = ({ adTagUrl, isOpen, onComplete }) => {
    if (!isOpen || !adTagUrl) {
        return null;
    }

    return (
        <VideoPrerollModal
            adTagUrl={adTagUrl}
            onComplete={onComplete}
        />
    );
};

VideoPrerollContainer.propTypes = exact({
    adTagUrl: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    onComplete: PropTypes.func.isRequired,
});

const mapStateToProps = (state) => ({
    adTagUrl: state.aovivoBar.MediaPlayer.videoPrerollAdTagUrl,
    isOpen: state.aovivoBar.MediaPlayer.videoPrerollOpen || false,
});

const mapDispatchToProps = (dispatch) => ({
    onComplete: () => {
        dispatch(completeVideoPreroll());
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(VideoPrerollContainer);
